<template>
  <layout-main-inner title="发货单">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="form">
        <!-- <status-select v-model="config.status" /> -->
        <ent-warehouse-auto-select
          v-model="config.warehouseNo"
          style="margin-left:10px"
          :callback="() => {handleCurrentChange(1)}" />
        <el-input
          v-model="config.outOrderCode"
          clearable=""
          placeholder="请输入出库单号"
          style="width: 180px;margin-left:10px"
          @keyup.enter.native="handleCurrentChange(1)">
        </el-input>
        <el-input
          v-model="config.code"
          clearable=""
          placeholder="请输入发货单号"
          style="width: 200px;margin-left:10px">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="发货单号"
          width="135"
          prop="code">
          <template slot-scope="{row}">
            <link-route>
              <span @click="linkto(row)">{{ row.code }}</span>
            </link-route>
            <!-- <link-route :link-to="`/orders-detail?salesOrderId=${row.bizOrderId}&code=${row.bizOrderCode}&activeName=2`">
              {{ row.code }}
            </link-route> -->
          </template>
        </el-table-column>
        <el-table-column
          label="出库单号"
          width="135"
          prop="outOrderCode">
        </el-table-column>
        <el-table-column
          label="订单号"
          width="170"
          prop="salesOrderCode">
        </el-table-column>
        <el-table-column
          label="发货仓库"
          min-width="200"
          prop="warehouseNo">
          <template slot-scope="{row}">
            {{ row.warehouseNo | warehouseName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="包裹数量"
          width="70"
          prop="packageNum">
        </el-table-column>
        <el-table-column
          label="发货类型"
          width="70"
          prop="type">
          <template slot-scope="{row}">
            {{ row.transType | transTypeName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="面单打印状态"
          prop="printStatus"
          width="95">
          <template slot-scope="{row}">
            {{ row.printStatus | printStatusName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="发货状态"
          width="70"
          prop="status">
          <template slot-scope="{row}">
            {{ row.status | outStatusName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="140">
          <template slot-scope="{row}">
            {{ row.createTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="95">
          <template slot-scope="{row}">
            <el-dropdown>
              <el-button type="warning">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="row.printStatus === 0 || row.printStatus === 2 || row.printStatus === 9"
                  @click.native="outcancel(row)">直接打印</el-dropdown-item>
                <el-dropdown-item
                  v-if="row.printStatus === 0 || row.printStatus === 2 || row.printStatus === 9"
                  @click.native="outcancel(row)">重新打印</el-dropdown-item>
                <!-- <el-dropdown-item @click.native="outdetail(row)">查看明细</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination
          background
          :current-page.sync="config.pageNum"
          :page-size="config.pageSize"
          layout="total, prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange">
        </el-pagination>
      </template>
    </layout-card-wrap>
    <detail-modal ref="detail" />
    <!-- <printer-select-modal ref="printer" /> -->
    <order-send-modal
      ref="send"
      :callback="fetchList" />
  </layout-main-inner>
</template>

<script>
import EntWarehouseAutoSelect from '../../components/business/ent-warehouse-auto-select.vue'
import { mapState } from 'vuex'
import DetailModal from './busi/detail-modal.vue'
// import StatusSelect from './status-select.vue'
import OrderSendModal from './busi/order-send-modal.vue'
// import PrinterSelectModal from './busi/printer-select-modal.vue'

export default {
  name: 'DeliveryOrderList',
  components: { DetailModal, EntWarehouseAutoSelect, OrderSendModal },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        code: '',
        outOrderCode: '',
        warehouseNo: null,
        status: null
        // sorts: [
        //   {
        //     columnName: 'createTime',
        //     sortType: 'DESC'
        //   }
        // ]
        // orderNumber: '',
        // isOriginalOrder: 1,
        // vendorId: null,
        // status: null
      },
      list: [],
      total: 0,
      current: {},
      goodsreturn: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      query: state => state.common.query
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    linkto(row) {
      this.$store.dispatch('outstock/getoutlist', {
        payload: {
          code: row.outOrderCode
        },
        success: (res) => {
          const records = res.data.data.records
          if (records.length === 0) {
            this.$message.error('出库单不存在')
            return
          }
          const item = records[0]
          const { type, bizOrderCode, bizOrderId } = item
          if (type === 21) {
            this.$router.push(`/orders-detail?vendorId=${row.parentOwnerCode}&salesOrderId=${bizOrderId}&code=${bizOrderCode}&activeName=5`)
          }
          if (type === 23) {
            this.$router.push(`/transfer-stock-detail?vendorId=${row.parentOwnerCode}&allocateOrderId=${bizOrderId}&code=${bizOrderCode}&activeName=3`)
          }
        },
        fail: () => {}
      })
    },
    addsend(row) {
      console.log(row)
      this.$refs.send.fetch(row.id)
    },
    printWrap(row) {
      this.$confirm('是否打印面单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (row.printStatus === 0 || row.printStatus === 9) {
            this.expressprint(row, () => {
              this.printHtml(row)
            })
          } else {
            this.printHtml(row)
          }
        })
    },
    expressprint(row, cb) {
      this.loading = true
      this.$store.dispatch('outstock/expressprint', {
        payload: {
          printFlag: 1,
          orderIdList: [row.id]
        },
        success: () => {
          this.loading = false
          this.fetchList()
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    outdetail(row) {
      this.$refs.detail.fetch(row)
    },
    printHtml(row) {
      this.loading = true
      this.$store.dispatch('outstock/sendlist', {
        payload: {
          pageNum: 1,
          pageSize: 1000,
          outOrderCode: row.code
        },
        success: (res) => {
          this.loading = false
          console.log(res)
          // printTemplate(res.data.data.records)
          this.$refs.printer.fetch(res.data.data.records)
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    outcancel(row) {
      this.$confirm('是否取消出库单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('outstock/outcancel', {
            payload: {
              outOrderId: row.id
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('outstock/getsendlist', {
        payload: {
          ...this.config
          // status: this.config.status !== null ? [this.config.status] : null
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.data.total
          this.list = res.data.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>

